import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import TeacherCourse from "./routes/TeacherCourse";

export default store => ({
  path: "teacher-courses",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "teacher-courses" */ "./components/TeacherCoursesWrapper"
      ),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [TeacherCourse(store)],
});
